<template>
  <div class="privacy-policy">
    <div class="container">
      <div class="content-wrapper">
        <h1 class="title">Política de Privacidad</h1>
        <p class="last-updated">Última actualización: {{ lastUpdated }}</p>

        <section class="policy-section">
          <h2>Introducción</h2>
          <p>
            En ChillByte, nos tomamos muy en serio la privacidad de nuestros usuarios. 
            Esta Política de Privacidad describe cómo recopilamos, usamos y protegemos 
            su información personal.
          </p>
        </section>

        <section class="policy-section">
          <h2>Información que Recopilamos</h2>
          <p>
            Podemos recopilar información personal que usted nos proporciona voluntariamente, 
            incluyendo pero no limitado a:
          </p>
          <ul>
            <li>Nombre y apellidos</li>
            <li>Dirección de correo electrónico</li>
            <li>Número de teléfono</li>
            <li>Información de la empresa</li>
            <li>Cualquier otra información que decida compartir con nosotros</li>
          </ul>
        </section>

        <section class="policy-section">
          <h2>Cómo Usamos Su Información</h2>
          <p>
            Utilizamos la información recopilada exclusivamente para:
          </p>
          <ul>
            <li>Responder a sus consultas y solicitudes</li>
            <li>Proporcionar nuestros servicios</li>
            <li>Mejorar nuestra página web y servicios</li>
            <li>Comunicarnos con usted sobre nuestros servicios</li>
          </ul>
        </section>

        <section class="policy-section highlight">
          <h2>No Compartimos Su Información</h2>
          <p class="emphasis">
            <strong>ChillByte NO comparte, vende, alquila ni divulga su información personal 
            a terceros bajo ninguna circunstancia.</strong> Su información permanece confidencial 
            y es utilizada únicamente por nuestro equipo interno para los fines mencionados anteriormente.
          </p>
        </section>

        <section class="policy-section">
          <h2>Seguridad de la Información</h2>
          <p>
            Implementamos medidas de seguridad técnicas y organizativas apropiadas para 
            proteger su información personal contra acceso no autorizado, alteración, 
            divulgación o destrucción.
          </p>
        </section>

        <section class="policy-section">
          <h2>Sus Derechos</h2>
          <p>
            Usted tiene derecho a:
          </p>
          <ul>
            <li>Acceder a su información personal</li>
            <li>Solicitar la corrección de datos inexactos</li>
            <li>Solicitar la eliminación de su información</li>
            <li>Oponerse al procesamiento de su información</li>
            <li>Solicitar la portabilidad de sus datos</li>
          </ul>
        </section>

        <section class="policy-section">
          <h2>Cookies y Tecnologías Similares</h2>
          <p>
            Nuestro sitio web puede utilizar cookies y tecnologías similares para mejorar 
            su experiencia de navegación. Puede configurar su navegador para rechazar 
            cookies, aunque esto puede afectar la funcionalidad del sitio.
          </p>
        </section>

        <section class="policy-section">
          <h2>Cambios a Esta Política</h2>
          <p>
            Nos reservamos el derecho de actualizar esta Política de Privacidad en cualquier momento. 
            Los cambios serán publicados en esta página con una nueva fecha de actualización.
          </p>
        </section>

        <section class="policy-section">
          <h2>Contacto</h2>
          <p>
            Si tiene preguntas sobre esta Política de Privacidad o desea ejercer sus derechos, 
            puede contactarnos a través de nuestro formulario de contacto o por correo electrónico.
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyView',
  metaInfo: {
    title: 'Política de Privacidad - ChillByte',
    meta: [
      {
        name: 'description',
        content: 'Política de privacidad de ChillByte. No compartimos su información con terceros.'
      }
    ]
  },
  data() {
    return {
      lastUpdated: 'Noviembre 2025'
    }
  }
}
</script>

<style scoped lang="scss">
.privacy-policy {
  min-height: 100vh;
  padding: 80px 0 60px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);

  .container {
    max-width: 900px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .content-wrapper {
    background: white;
    border-radius: 16px;
    padding: 60px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);

    @media (max-width: 768px) {
      padding: 40px 30px;
    }

    @media (max-width: 480px) {
      padding: 30px 20px;
    }
  }

  .title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 10px;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  .last-updated {
    text-align: center;
    color: #7f8c8d;
    font-size: 0.95rem;
    margin-bottom: 40px;
    font-style: italic;
  }

  .policy-section {
    margin-bottom: 40px;

    &:last-child {
      margin-bottom: 0;
    }

    h2 {
      font-size: 1.6rem;
      font-weight: 600;
      color: #34495e;
      margin-bottom: 16px;
      border-bottom: 2px solid #3498db;
      padding-bottom: 8px;

      @media (max-width: 768px) {
        font-size: 1.4rem;
      }
    }

    p {
      font-size: 1.05rem;
      line-height: 1.8;
      color: #555;
      margin-bottom: 16px;
    }

    ul {
      margin-left: 20px;
      margin-bottom: 16px;

      li {
        font-size: 1.05rem;
        line-height: 1.8;
        color: #555;
        margin-bottom: 10px;
      }
    }

    &.highlight {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 12px;
      padding: 30px;
      margin: 40px 0;

      h2 {
        color: white;
        border-bottom-color: rgba(255, 255, 255, 0.3);
      }

      p {
        color: white;
        font-size: 1.1rem;

        &.emphasis {
          font-size: 1.15rem;
          line-height: 2;
        }

        strong {
          font-weight: 700;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
